/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAaa_b2c_contact_usViewProps } from './aaa_b2c_contact_us';
//import { Button } from '@msdyn365-commerce-modules/utilities';

export default (props: IAaa_b2c_contact_usViewProps) => {
    return (
        <>
            {props.isLoginedIn ? (
                <div>
                    <div className={'col-auto col-sm-auto'}>
                        <span className={'b2c-contact-us-content-heading'}>
                            {props.stockistInfo.B2BCustomerName} {props.config.b2CContactUSContentHeading}
                        </span>
                        <span className={'jeweller-phone'}>{props.stockistInfo.Phone}</span>
                        <span className={'jeweller-email'}>{props.stockistInfo.Email}</span>
                        <span className={'b2c-contact-us-content-footer'}>{props.config.b2CContactUSContentFooter}</span>
                    </div>
                </div>
            ) : (
                <div className={'col-auto col-sm-auto'}>
                    <span className={'b2c-contact-us-content-heading'}>{props.config.b2CContactUSLivadiHeading}</span>
                    <span className={'jeweller-phone'}>{props.config.b2CContactUSLivadiPhone}</span>
                    <span className={'jeweller-email'}>{props.config.b2CContactUSLivadiEmail}</span>
                </div>
            )}
        </>
    );
};
